/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IAddressDisplayModel {
  bundesland?: null | string;
  city?: null | string;
  landId?: null | string;
  ortssuche?: null | string;
  postalcode?: null | string;
  street?: null | string;
}
export class AddressDisplayModel extends BaseModel implements IAddressDisplayModel {
  bundesland?: null | string;
  city?: null | string;
  landId?: null | string;
  ortssuche?: null | string;
  postalcode?: null | string;
  street?: null | string;
}
class BaseAddressDisplayModelFormGroup extends FormGroup {
  private static _instance: AddressDisplayModelFormGroup;
  
  public static get Instance(): AddressDisplayModelFormGroup {
    this._instance = new AddressDisplayModelFormGroup({
      bundesland: new FormControl(null),
      city: new FormControl(null),
      landId: new FormControl(null),
      ortssuche: new FormControl(null),
      postalcode: new FormControl(null),
      street: new FormControl(null),
    });

    return this._instance;
  }
}


export class AddressDisplayModelFormGroup extends BaseAddressDisplayModelFormGroup {
  public get Bundesland(): FormControl {
    return this.controls["bundesland"] as FormControl;
  }
  public get City(): FormControl {
    return this.controls["city"] as FormControl;
  }
  public get LandId(): FormControl {
    return this.controls["landId"] as FormControl;
  }
  public get Ortssuche(): FormControl {
    return this.controls["ortssuche"] as FormControl;
  }
  public get Postalcode(): FormControl {
    return this.controls["postalcode"] as FormControl;
  }
  public get Street(): FormControl {
    return this.controls["street"] as FormControl;
  }
  

}

export module AddressDisplayModelForm
  {
    export class FormFields
    {
      static _bundesland: string = "bundesland";
      static _city: string = "city";
      static _landId: string = "landId";
      static _ortssuche: string = "ortssuche";
      static _postalcode: string = "postalcode";
      static _street: string = "street";
    }
  }

